import { FilterTypes } from '../../store/reducers/productFilter.reducer';
import { ProductTypes } from '../../types/product/product';

export const isFromCategory = (
  category: FilterTypes['category']
): Predicate<ProductTypes> => product =>
  category !== '0'
    ? product.categorieproduits.map(cat => cat.id).includes(category)
    : category === '0'
    ? true
    : true;
